<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="display-1 font-weight-normal mb-6 text-center">
          Vamos preencher o período de recuperação do ICMS para a etapa do ICMS
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <validation-provider
          v-slot="{ errors, valid }"
          rules="required"
        >
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-recuperacao-analise', {
                step: 'recuperacao-analise',
                complete: $event,
              })
            "
          />
          <v-select
            v-model="periodoRecuperacaoSelecionado"
            outlined
            :error-messages="errors"
            :items="itemsPeriodoRecuperacao"
            label="Período de Recuperação do ICMS"
            placeholder="Selecione o período de recuperação do ICMS (n)"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    DatePicker:       () => import('@/components/general/DatePicker.vue'),
    ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
  },

  data: () => ({
    itemsPeriodoRecuperacao: [48, 60],
    periodoRecuperacaoSelecionado: null
  }),

  methods: {
    exportData() {
      return {
        periodoRecuperacaoSelecionado: this.periodoRecuperacaoSelecionado
      };
    }
  }
};
</script>